import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { GetConfigZoppyResponse } from '../../responses/integracao-zoppy/get-config-zoppy.response';
import { UpdateConfigZoppyRequest } from '../../requests/integracao-zoppy/update-config-zoppy.request';

@Injectable({
    providedIn: 'root',
})
export class IntegracaoZoppyService extends CommonService {
    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    private readonly apiUrl = `${environment.urlApiIntegracaoZoppy}Config`;

    public getConfig(paginaAtual: number = 0, dataInicial?: string | null, dataFinal?: string | null, idTipoLog?: number | null): Observable<GetConfigZoppyResponse> {
        let params = new HttpParams();
        params = params.append('paginaAtual', paginaAtual.toString());

        if (dataInicial) {
            params = params.append('dataInicial', dataInicial);
        }
        if (dataFinal) {
            params = params.append('dataFinal', dataFinal);
        }
        if (idTipoLog) {
            params = params.append('idTipoLog', idTipoLog.toString());
        }

        return this.httpClient
            .get<GetConfigZoppyResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public updateConfig(request: UpdateConfigZoppyRequest): Observable<ReturnStruct> {
        return this.httpClient
            .put<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
